import { createSlice } from '@reduxjs/toolkit';

const initialLCState = {
    lang: 'en',
    rtl: false,
    // lang: 'he',
    // rtl: true,
    isFullScreen: false
}

const lcSlice = createSlice({
    name: 'layoutConfiguration',
    initialState: initialLCState,
    reducers: {
        setRtl (state, actions) {
            state.rtl = actions.payload;
        },
        setLang (state, actions) {
            state.lang = actions.payload;
        },
        updateFullScreenStatus (state, actions) {
            state.isFullScreen = actions.payload;
        }
    }
})

export const lcActions = lcSlice.actions;
export default lcSlice;